export const STRIPE_CONFIG = {
    publishableKey: "pk_live_51QkTtaRqRsZpBbbqCxjvxA8pNbd2cDWYuYtRF7zQGatHFnDoM4U9xS9PHxxS7NrRWOJzhNNmFgX8SNVLhgdP7Jbn00C8XsEpUu",
    couponId: "qhWiQCJB",
    apiUrl: "https://stripe-intent.caloria.tech",
};

export const getStripeConfig = () => STRIPE_CONFIG;
